import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { push } from 'react-router-redux'

import {
  FETCH_MANAGER_BRANCH_MISSION_REQUEST,
  FETCH_MANAGER_BRANCH_MISSION_SUCCESS,
  FETCH_MANAGER_BRANCH_MISSION_ERROR,
  UPDATE_MANAGER_BRANCH_MISSION_REQUEST,
  UPDATE_MANAGER_BRANCH_MISSION_SUCCESS,
  UPDATE_MANAGER_BRANCH_MISSION_ERROR,
  GET_MENU_MISSION_FROM_LIST,
  RESET_MENU_MISSIONS,
  RESET_EDIT_MENU_MISSION,
  REMOVE_MENU_MISSION_SUCCESS,
  REMOVE_MENU_MISSION_ERROR,
  GET_PAGES,
  CLEAR_SUCCESS_MESSAGE,
  FETCH_MISSIONS_OPTIONS_REQUEST,
  FETCH_MISSIONS_OPTIONS_SUCCESS,
  FETCH_MISSIONS_OPTIONS_ERROR,
} from 'actionTypes'

const getPages = (page, data, dispatch) => {
  const qtt = data.length
  const qtd = 10
  let pages = Math.floor(qtt / qtd)
  if (qtt % qtd > 0) {
    pages += 1
  }
  const begin = (page - 1) * qtd
  const end = page * qtd
  data = data.slice(begin, end)
  fetchManagerBranchMissionSuccess(data, dispatch)

  return {
    type: GET_PAGES,
    pages,
    current: page,
    count: qtt,
  }
}

/*
 * REQUEST MENU_MISSION_LIST
 */
export const fetchManagerBranchMissions =
  (token, page = 1) =>
  (dispatch) => {
    dispatch(fetchManagerBranchMissionsRequest())

    return new Api(token, dispatch)
      .get(API_URL.MANAGER_BRANCH_MISSION_LIST)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(page, response.data, dispatch))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchManagerBranchMissionsError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchManagerBranchMissionsRequest = () => ({
  type: FETCH_MANAGER_BRANCH_MISSION_REQUEST,
})

export const fetchManagerBranchMissionSuccess = (data, dispatch) => {
  /* istanbul ignore else */
  if (data) {
    dispatch(managerBranchMissionSuccess(data))
  }
  dispatch(hideSpinner())
}

const managerBranchMissionSuccess = (data) => ({
  type: FETCH_MANAGER_BRANCH_MISSION_SUCCESS,
  payload: data,
})

export const fetchManagerBranchMissionsError = (error) => ({
  type: FETCH_MANAGER_BRANCH_MISSION_ERROR,
  payload: error,
})

/*
 * SAVE or UPDATE MANAGER_BRANCH_MISSION
 */
export const update = (token, params, onSuccess) => (dispatch) => {
  dispatch(updateManagerBranchMissionRequest())

  return new Api(token, dispatch)
    .post(API_URL.MANAGER_BRANCH_MISSION_SAVE, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateManagerBranchMissionSuccess(response.data))
      dispatch(hideSpinner())
      dispatch(fetchManagerBranchMissions(token))
      dispatch(fetchMissionsOptions(token))
      onSuccess && onSuccess()
    })
    .catch((error) => {
      dispatch(updateManagerBranchMissionError(error))
      dispatch(hideSpinner())
    })
}

export const updateManagerBranchMissionRequest = () => ({
  type: UPDATE_MANAGER_BRANCH_MISSION_REQUEST,
})

export const updateManagerBranchMissionSuccess = (data) => ({
  type: UPDATE_MANAGER_BRANCH_MISSION_SUCCESS,
  payload: data,
})

export const updateManagerBranchMissionError = (error) => ({
  type: UPDATE_MANAGER_BRANCH_MISSION_ERROR,
  payload: error,
})

/*
 * GET MENU_MISSION FROM LIST
 */
export const getMenuMission = (index) => (dispatch) => {
  dispatch({
    type: GET_MENU_MISSION_FROM_LIST,
    index,
  })

  dispatch(push(`/missions/${index}`))
}

/*
 * REMOVE MENU_MISSION
 */
export const remove = (token, lsMissionMenus, onSuccess) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.MANAGER_BRANCH_MISSION_REMOVE, lsMissionMenus)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(hideSpinner())
      dispatch(removeMissionSuccess())
      dispatch(fetchManagerBranchMissions(token))
      dispatch(fetchMissionsOptions(token))
      onSuccess && onSuccess()
    })
    .catch((error) => {
      dispatch(removeMissionError(error))
      dispatch(hideSpinner())
    })

export const removeMissionSuccess = () => ({
  type: REMOVE_MENU_MISSION_SUCCESS,
})

export const removeMissionError = (error) => ({
  type: REMOVE_MENU_MISSION_ERROR,
  payload: error,
})

export const resetMenuMissions = () => ({
  type: RESET_MENU_MISSIONS,
})

export const resetEditMenuMissions = () => ({
  type: RESET_EDIT_MENU_MISSION,
})

export const clearSuccessMessage = () => ({
  type: CLEAR_SUCCESS_MESSAGE,
})

export const fetchMissionsOptions = (token) => (dispatch) => {
  dispatch(fetchMissionsOptionsRequest())

  return new Api(token, dispatch)
    .get(API_URL.MANAGER_BRANCH_MISSION_LIST_MISSION)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchMissionsOptionsSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchMissionsOptionsError(error))
      dispatch(hideSpinner())
    })
}

export const fetchMissionsOptionsRequest = () => ({
  type: FETCH_MISSIONS_OPTIONS_REQUEST,
})

export const fetchMissionsOptionsSuccess = (data) => ({
  type: FETCH_MISSIONS_OPTIONS_SUCCESS,
  payload: data,
})

export const fetchMissionsOptionsError = (error) => ({
  type: FETCH_MISSIONS_OPTIONS_ERROR,
  payload: error,
})
